import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { FileUploadForm } from "./FileUploadForm";
import { useDispatch, useSelector } from "react-redux";
import authService from "../../services/auth.service";

const MasterInput = ({ field, formData, handleChange,signaturePreview,imagePreview,studentInformation,validationError }) => {
  const validationKeys=Object.keys(validationError)
  const [params]= useSearchParams();

  // console.log(studentInformation)

   
  
  if (!field) return null;

  if(field.type==="break" && field.breakTitle!==""){
    return <div  style={{ width: "100%" }}>
          <h5 style={{fontSize:'20px',fontWeight:'600',borderBottom:'1px dotted gray', padding:"10px"}}>{field.breakTitle}</h5>
         
        </div>
     
  }
  // if(field.type==="break" && field.breakTitle!==""){
  //   return <div  style={{ width: "100%" }}>
  //         <h5 style={{fontSize:'20px',fontWeight:'normal',borderBottom:'}}>{field.breakTitle}</h5>
         
  //       </div>
     
  // }

  // Disable fields: name, gender, email, category, urn
  const disableFields = ["applicant_name", "gender", "email", "category",];
  // Disable sub_category and caste_certificate_number if category is GENERAL
  const isGeneral = formData["category"] === "GENERAL";
  const extraDisable = ["sub_category", "caste_certificate_number"];
  const commonProps = {
    name: field.name,
    value: formData[field.name] || '',
    onChange: handleChange,
    required: true,
    disabled: disableFields.includes(field.name) || (isGeneral && extraDisable.includes(field.name))
  };


  


  if (field.type === "file") {
 
    if(field.isAJAXUpload === true) {
      return <FileUploadForm name={field.name} accept={field.accept} label={field.label} documents={studentInformation.documents}/>
    }
    return (
      <div className="form-input">
        <label>
          <p>{field.label} {field.required==false?"":<span className="required">*</span>} </p>
          <input className="input-form" type="file" name={field.name} accept={field.accept} onChange={e => handleChange(e, field)} required />
        </label>
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
        {field.name === "image" && imagePreview && (
          <img src={imagePreview} alt="Preview" style={{ maxWidth: 150, maxHeight: 150, marginTop: 10 }} />
        )}
        {field.name === "signature" && signaturePreview && (
          <img src={signaturePreview} alt="Signature Preview" style={{ maxWidth: 150, maxHeight: 150, marginTop: 10 }} />
        )}
      </div>
    );
  }

  if (field.type === "select") {
    if(field.name=="second_major_subject" && window.location.toString().split("/")[4]=="bsc"){
     let subs ; 
      if(params.get("subject_group")=="ZBC"){
      subs =["Botany","Chemistry","Zoology"];
    }else if(params.get("subject_group")=="PCM"){
      subs =["Physics","Chemistry","Maths"];
    } else{
      subs =[];
    }
      return (
      <div className="form-input">
        <label>{field.label}{field.required==false?"":<span className="required">*</span>}</label>
        <select {...commonProps}>
          <option value="">Select</option>
          {subs.map((val, i) => (
            <option key={i} value={val} disabled={field.name === "first_major_subject" && val === "Chemistry"}   >{val}</option>
          ))}
        </select>
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
    }
    return (
      <div className="form-input">
        <label>{field.label}{field.required==false?"":<span className="required">*</span>}</label>
        <select {...commonProps}>
          <option value="">Select</option>
          {field.values.map((val, i) => (
            <option key={i} value={val} disabled={field.name === "first_major_subject" && val === "Chemistry"}   >{val}</option>
          ))}
        </select>
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
  }

  if (["text", "email", "tel", "number","date",].includes(field.type)) {
    return (
      <div className="form-input">
        <label>{field.label} {field.required==false?"":<span className="required">*</span>}</label>
        <input   className="input-form" type={field.type} {...commonProps}   />
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
  }

  if (field.type === "textarea") {
    return (
      <div className="form-input">
        <label>{field.label}{field.required==false?"":<span className="required">*</span>}</label>
        <textarea {...commonProps}></textarea>
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
  }

  if (field.type === "radio") {
    return (
      <div className="form-input">
        <label>{field.label}{field.required==false?"":<span className="required">*</span>}</label>
        {field.values.map((val, i) => (
          <label key={i}>
            <input
            className="input-form"
              type="radio"
              name={field.name}
              value={val}
              checked={formData[field.name] === val}
              onChange={e => handleChange(e, field)}
              required
            /> {val}
          </label>
          
        ))}
        <span className="error">{validationKeys.includes(field.name)?validationError[field.name][0]:''}</span>
      </div>
    );
  }

  if (field.type === "checkbox") {
    return (
      <div className="form-input">
        <label>{field.label} {field.required==false?"":<span className="required">*</span>}</label>
        {field.values && Array.isArray(field.values) ? (
          field.values.map((val, i) => (
            <label key={i}>
              <input
                type="checkbox"
                name={field.name}
                value={val}
                 checked={Array.isArray(formData[field.name]) ? formData[field.name].includes(val) : false}
                onChange={e => handleChange(e, field)}
              /> {val}
            </label>
          ))
        ) : (
          <label>
            <input
              type="checkbox"
              name={field.name}
              checked={formData[field.name] || false}
              onChange={e => handleChange(e, field)}
            /> {field.name}
          </label>
        )}
        <span className="error">{validationKeys.includes(field.name.replace("[]",""))?validationError[field.name.replace("[]","")][0]:''}</span>
      </div>
    );
  }

  if (field.type === "info") {
    return (
      <div className="declaration-text">
        <p>{field.name}</p>
      </div>
    );
  }

  return null;
};

export default MasterInput;
